/*
 * user.dto.ts
 *
 * TODO: Find a way to share entity and dto definition!!!
 * TODO: One MONORepo may be a possible way!!!
 * Reference 1eLC-eSystem/eLC-eSystem-API/src/user/entity/user.entity.ts
 * Reference 1eLC-eSystem/eLC-eSystem-API/src/user/dto/user.dto.ts
 *
 * APP              <==>  API
 * mtUserDto        <==   mcUserEntity
 * mtUserCreateDto   ==>  mcUserCreateDto
 * mtUserUpdateDto   ==>  mcUserUpdateDto
 *
 */
import { mcUtils } from 'src/utils/utils';
import type { mtUserStaffDto, mtUserStaffCreateDto, mtUserStaffUpdateDto } from 'src/user/dto/userStaff.dto';
import type {
  mtUserQualificationDto,
  mtUserQualificationCreateDto,
  mtUserQualificationUpdateDto,
} from 'src/user/dto/userQualification.dto';
//
export type mtUserDto = {
  cpinID: number;
  cpidCreatedAt: Date;
  cpidUpdatedAt: Date;
  cpidDeletedAt: Date | null;
  //
  cpinIDEmployee: number;
  cpinIDTrainer: number;
  cpinIDTrainee: number;
  //
  cpibIsActive: boolean;
  cpieUserStatus: string; //eTypeUserStatus;
  cpidDateStart: string; //Date;
  cpidDateEnd: string | null; //Date | null;
  cpisNameLogin: string;
  cpisPassword: string;
  cpisNameFull: string;
  cpisNameDisplay: string;
  cpieUserType: string; //eTypeUserType;
  cpiaUserRole: string[];
  cpidDOB: string | null; //Date;
  cpieGender: string; //eTypeGender;
  cpisNOKName: string;
  cpisNOKRelation: string;
  cpisNOKContact: string;
  cpisEmail1: string;
  cpisEmail2: string | null;
  cpisMobile1: string;
  cpisMobile2: string;
  cpisTablet1: string;
  cpisAddressLine1: string;
  cpisAddressLine2: string;
  cpisAddressLine3: string;
  cpisPostalCode: string;
  cpiaUserSession: string[]; // NOTE: Update: not allowed. It is updated by the system;!!! */
  //
  cpibIsAttendance: boolean;
  //
  // UserStaff
  //
  cpiaUserStaff: mtUserStaffDto[];
  //
  // UserQualification
  //
  cpiaUserQualification: mtUserQualificationDto[];
  //
  // Date => date-string for q-input
  //
  cpisDateStart: string;
  cpisDateEnd: string;
  cpisDOB: string;
};
//
export type mtUserCreateDto = Omit<
  mtUserDto,
  | 'cpinID'
  | 'cpidCreatedAt'
  | 'cpidUpdatedAt'
  | 'cpidDeletedAt'
  | 'cpiaUserSession'
  | 'cpiaUserStaff'
  | 'cpiaUserQualification'
  | 'cpisDateStart'
  | 'cpisDateEnd'
  | 'cpisDOB'
> & {
  cpiaUserStaff: mtUserStaffCreateDto[];
  cpiaUserQualification: mtUserQualificationCreateDto[];
};
//
// Ops: Create | Update
//
export type mtUserUpdateDto = Omit<
  mtUserDto,
  | 'cpidCreatedAt'
  | 'cpidUpdatedAt'
  | 'cpidDeletedAt'
  | 'cpiaUserSession'
  | 'cpiaUserStaff'
  | 'cpiaUserQualification'
  | 'cpisDateStart'
  | 'cpisDateEnd'
  | 'cpisDOB'
> & {
  cpiaUserStaff: mtUserStaffUpdateDto[];
  cpiaUserQualification: mtUserQualificationUpdateDto[];
};
//
export const moUserInit: mtUserDto = {
  cpinID: Date.now() * -1,
  cpidCreatedAt: new Date(),
  cpidUpdatedAt: new Date(),
  cpidDeletedAt: null,
  //
  cpinIDEmployee: 0,
  cpinIDTrainer: 0,
  cpinIDTrainee: 0,
  //
  cpibIsActive: false,
  cpieUserStatus: 'ePENDING',
  cpidDateStart: mcUtils.cpsoQuasarDate.cpif2YYYYMMDD(new Date().toString()),
  cpidDateEnd: null,
  cpisNameLogin: '',
  cpisPassword: '',
  cpisNameFull: '',
  cpisNameDisplay: '',
  cpieUserType: 'eUNDEFINED',
  cpiaUserRole: ['eUNDEFINED'],
  cpidDOB: null,
  cpieGender: 'eUNKNOWN',
  cpisNOKName: '',
  cpisNOKRelation: '',
  cpisNOKContact: '',
  cpisEmail1: '',
  cpisEmail2: null, // '',
  cpisMobile1: '',
  cpisMobile2: '',
  cpisTablet1: '',
  cpisAddressLine1: '',
  cpisAddressLine2: '',
  cpisAddressLine3: '',
  cpisPostalCode: '',
  cpiaUserSession: [], // NOTE: Update: not allowed. It is updated by the system;!!! */
  //
  cpibIsAttendance: true,
  //
  // UserStaff
  //
  cpiaUserStaff: [],
  //
  // UserQualification
  //
  cpiaUserQualification: [],
  //
  // Date => date-string for q-input
  //
  cpisDateStart: mcUtils.cpsoQuasarDate.cpifGetToday('-'),
  cpisDateEnd: '',
  cpisDOB: '',
};
//
export type mtPSTrainerListOptionDto = Partial<mtUserDto>;
//
export const moPSTrainerListOptionDtoInit: mtPSTrainerListOptionDto = {
  cpinID: 0,
  cpinIDEmployee: 0,
  cpinIDTrainer: 0,
  cpibIsActive: true,
  cpisNameFull: 'UNDEFINED',
  cpisNameDisplay: 'UNDEFINED',
};
//#end#
